import React from "react"
import { TextField } from "material-ui"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import AccountStore from "../../stores/AccountStore"
import * as accountActions from "../../actions/AccountActions"
import _ from "lodash"

interface IState {
    singularField: string
    pluralField: string
}

interface IProps {
    singularField:string
    pluralField : string;
    fieldType : 'JobFieldLabels' | 'PositionFieldLabels' | "PhaseFieldLabels"
    singularKey : 'SingularJobLabel' | 'SingularPositionLabel' | "SingularPhaseLabel"
    pluralKey : 'PluralJobLabel' | 'PluralPositionLabel' | "PluralPhaseLabel"
    pluralLabel:string
    singularLabel:string
}

export default class CustomPositionFieldLable extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)

        this.state = {
            singularField: props.singularField,
            pluralField: props.pluralField
        }
        autobind(this)
    }

    handleSave() {
        const CustomFieldSettings = AccountStore.getCurrentAccountSettings() && AccountStore.getCurrentAccountSettings().CustomFieldSettings

        CustomFieldSettings[this.props.fieldType][this.props.singularKey] = this.state.singularField

        CustomFieldSettings[this.props.fieldType][this.props.pluralKey] = this.state.pluralField
       
        accountActions.patchAccount(AccountStore.getCurrentAccount().Id, {
            AccountSettings: {
                CustomFieldSettings
            }
        })
    }
    saveCustomFieldSettings = _.debounce(() => this.handleSave(), 1500)

    render() {
        console.log(this.props.fieldType,"fieldType")
        return (
            <div style={{ width: 500, padding: "20px 40px" }}>
                <TextField
                    floatingLabelText={this.props.singularLabel}
                    value={this.state.singularField}
                    style={{ width: 350 }}
                    onChange={(event) => this.setState({ singularField: event.target.value }, () => this.saveCustomFieldSettings())}
                />

                <TextField
                    floatingLabelText={this.props.pluralLabel}
                    value={this.state.pluralField}
                    style={{ width: 350 }}
                    onChange={(event) => this.setState({ pluralField: event.target.value }, () => this.saveCustomFieldSettings())}
                />
            </div>
        )
    }
}
